import axios from 'axios';
let link = window.location.href
let url = ''
if (link.includes('http://localhost:3000/')) {
  url = 'http://localHost:5002/'
}
else {
  url = 'https://back.plataformaamrbi.com:5002/'
}

const api = axios.create({
  baseURL: url
});
export default api;
